
import { Component, Vue } from "vue-property-decorator";

import { IDefaultShippingOrderModel } from "@/api/types";
import Pagination from "@/components/Pagination/index.vue";
import { Message } from "element-ui";
// import { cloneDeep } from "lodash";
import { ShippingOrderModel } from "@/model/shipping-order";
// 查看产品系统弹窗
import ProductSystem from "./cpns/details.vue";
// 新建/编辑表单
import NewBuild from "./cpns/newBuild.vue";
import {
  deleteProduct,
  disabledProduct,
  searchProducts,
  uploadProduct,
  uploadProductPerformanceTarget,
} from "@/api/product-business";
import { getProduct } from "@/api/product-category";
import { Product } from "@/model/productCategory";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";
import BaseUcenterTable from "@/components/BaseTable/index.vue";
import BaseTable from "@/components/BaseTable/index.vue";
import { getProductManagerUser } from "@/api/users";
import { TableRowData } from "@/model/HqPackingListModels";

@Component({
  name: "ProductCategoryManagement",
  components: {
    BaseTable,
    BaseUcenterTable,
    Pagination,
    ProductSystem,
    NewBuild,
  },
})
export default class extends Vue {
  private productList: ProductTable[] = [];
  public current: Product = new Product();

  async editProduct(productId: string, params: string, type: string) {
    const data: any = await getProduct(productId);
    this.current = data;
    this.dialogShow(params, type);
  }

  public toNumberManager(row) {
    this.$router.push({
      name: "hqProductNumberManagement",
      query: {
        id: row.id,
        name: row.productName,
        productId: row.productId,
        sn: row.sn,
      },
    });
  }

  private exportExcel() {
    const data = this.productList.map((value) => {
      return {
        // packingState: value.state.desc,
        // grossWeight: value.packingWeight.grossWeight,
        // netWeight: value.packingWeight.netWeight,
        ...value,
      };
    });
    const headers = [
      "华强品名",
      "产品经理",
      "产品系统",
      "型号数量",
      "SKU数量",
      "绩效目标",
      "当前绩效",
    ];
    const fieldNames = [
      "productName",
      "managerId",
      "productCategory",
      "modelQuantity",
      "skuQuantity",
      "performanceGoals",
      "currentPerformance",
    ];
    exportJson2Excel(
      headers,
      formatJson(fieldNames, data),
      `产品层级管理-${new Date()}`
    );
  }

  private files: File[] = [];

  // 点击显示弹窗
  public dialogShow(params: string, type: string) {
    this.$refs[params]["type"] = type || "";
    this.$refs[params]["dialogVisible"] = true;
  }

  public productManagerList = [];
  public active_name = "1";
  private tableKey = 0;
  public shippingOrder: IDefaultShippingOrderModel[] = [];

  private total = 0;
  private selectedRow: ShippingOrderModel = new ShippingOrderModel();

  //对话框的一个状态
  private dialogStatus = "";
  private dialogFormVisible = false;
  private containerTypeVisible = false;
  private confirmPutShippingVisible = false;

  configuredContainerTypes = [{ id: null, name: null, value: null }];
  private listParam = {
    productManagerId: null,
    type: "FLAGSHIP",
    productCategoryId: null,
    productName: null,
    pageNumber: 1,
    pageSize: 20,
  };

  created() {
    this.getList();
    getProductManagerUser().then((res: any) => {
      this.productManagerList = res;
    });
  }

  private canEdit(row: any) {
    let text = "彩盒彩带中性包装汽车配件";
    if (text.indexOf(row.productCategory) > -1) {
      return false;
    }
    return true;
  }

  private handleFilter() {
    this.listParam.pageNumber = 1;
    this.getList();
  }

  private gotoProductSystemManagement() {
    this.$router.push("/productSystemManagement");
  }

  private loading = false;
  private async getList() {
    this.loading = true;
    this.current = new Product();
    const params = { ...this.listParam };
    await searchProducts(params).then((data:any) => {
      this.productList = data.list;
      this.listParam.pageNumber = +data.page;
      this.listParam.pageSize = +data.size;
      this.total = +data.total;
      this.loading = false;
    }).catch(err => {
      console.log(err);
      this.loading = false;
    });
  }

  private async changeDisabledState(row: any) {
    await disabledProduct(row.id).then(() => {
      this.$message({
        type: "success",
        message: "操作成功!",
      });
    });
    this.getList();
  }

  private async removeProduct(row: any) {
    await deleteProduct(row.id).then(() => {
      this.$message({
        type: "success",
        message: "操作成功!",
      });
    });
    this.getList();
  }

  private async tabHandleClick() {
    this.productList = [] as any;
    this.listParam.pageNumber = 1;
    this.listParam.pageSize = 10;
    this.total = 0;
    this.getList();
  }

  private addFile(file: File) {
    if (file.size / 1024 / 1024 >= 100) {
      Message({
        message: "上传的文件大小不能超过100M!",
        type: "error",
        duration: 2 * 1000,
      });
      return;
    }
    this.files.push(file);
  }

  private async handleUpload(product: boolean) {
    let formData = new window.FormData();
    formData.append("file", this.files.pop());
    if (product) {
      await uploadProduct(formData).then(() => {
        this.$notify({
          title: "成功",
          message: "上传成功",
          type: "success",
          duration: 2000,
        });
      });
    } else {
      await uploadProductPerformanceTarget(formData).then(() => {
        this.$notify({
          title: "成功",
          message: "上传成功",
          type: "success",
          duration: 2000,
        });
      });
    }
    this.files = [];
    //todo 刷新列表
  }
}

class ProductTable {
  id: string;
  productName: string;
  managerId: string;
  productCategory: string;
  modelQuantity: string;
  skuQuantity: string;
  performanceGoals: string;
  currentPerformance: string;
}
